<div class="input-group">
  @if (dateRange) {
    <app-material-date-range
      id="selectedDateRangeGregorian"
      class="ms-6"
      [singleDateSelector]="singleDate"
      [(dateRange)]="dateRange"
      [(jalali)]="jalali"
      (dateRangeChange)="changeDate($event)">
    </app-material-date-range>
  }

  @if (visibleOrganisation && jalali) {
    <app-material-organisation-selector
      class="pg-component ms-1"
      style="text-align: center"
      placeholder="Company"
      [(ngModel)]="selectedOrganisation"
      (ngModelChange)="changeOrganisation($event)"
      [organisationLanguage]="'fa'"
      name="organisation"
      [organisations]="organisations"
      [required]="true">
    </app-material-organisation-selector>
  }

  @if (visibleOrganisation && !jalali) {
    <app-material-organisation-selector
      class="pg-component ms-1"
      style="text-align: center"
      placeholder="Company"
      [(ngModel)]="selectedOrganisation"
      (ngModelChange)="changeOrganisation($event)"
      [organisationLanguage]="'en'"
      name="organisation"
      [organisations]="organisations"
      [required]="true">
    </app-material-organisation-selector>
  }

  @if (excelExport) {
    <button
      class=" ms-1"
      mat-stroked-button
      (click)="xlsxReport()">
      <mat-icon>
        description
      </mat-icon>
      Excel Report
    </button>
  }

  @if (visibleButton) {
    <button
      class="ms-1"
      mat-stroked-button
      (click)="lpgDistQuotaDataEntry()">
      <mat-icon>
        edit
      </mat-icon>
      Quota
    </button>
  }
</div>